module.exports = __webpack_public_path__ + "img/pr-8.79283694.png";